export default {
  Submit: {
    en: 'Submit',
    de: 'Senden',
  },

  Create: {
    en: 'Create',
    de: 'Erstellen',
  },

  'Email address': {
    en: 'Email address',
    de: 'E-Mail Adresse',
  },

  footer_01: {
    en: 'Contact',
    de: 'Kontakt',
  },

  footer_02: {
    en: 'Email',
    de: 'E-Mail',
  },

  footer_03: {
    en: 'Authentication',
    de: 'Authentifizieren',
  },

  footer_04: {
    en: 'Register',
    de: 'Registrieren',
  },

  footer_05: {
    en: 'Login',
    de: 'Login',
  },

  footer_06: {
    en: 'Company',
    de: 'Unternehmen',
  },

  footer_07: {
    en: 'Legal',
    de: 'Impressum',
  },

  footer_08: {
    en: 'Privacy',
    de: 'Datenschutz',
  },

  footer_09: {
    en: 'Terms',
    de: 'AGB',
  },

  separator_h_01: {
    en: 'You need more than three emails a day?',
    de: 'Du brauchst mehr als drei E-Mails am Tag?',
  },

  separator_cta_01: {
    en: 'Get in touch',
    de: 'Kontaktiere uns',
  },

  separator_h_02: {
    en: 'You have further questions?',
    de: 'Du hast weitere Fragen?',
  },

  separator_cta_02: {
    en: 'Get in touch',
    de: 'Kontaktiere uns',
  },

  separator_h_03: {
    en: 'Directly give it a go?',
    de: 'Lieber direkt ausprobieren?',
  },

  separator_cta_03: {
    en: 'Try here',
    de: 'Hier testen',
  },

  separator_h_04: {
    en: 'Ready to get started?',
    de: 'Bereit um loszulegen?',
  },

  separator_cta_04: {
    en: 'Register',
    de: 'Registrieren',
  },

  Login: {
    en: 'Login',
    de: 'Login',
  },

  Register: {
    en: 'Register',
    de: 'Registrieren',
  },

  'Test now': {
    en: 'Test now',
    de: 'Jetzt testen',
  },

  Pricing: {
    en: 'Pricing',
    de: 'Preise',
  },
}
